<template>
  <div>
    <!--page header section start-->
    <!--<section class="page-header position-relative overflow-hidden ptb-120 child-phone-section text-white" >
        <div class="container">
            <div class="row">
                <div class="col-lg-8 col-md-12">
                    <h1 class="display-5 fw-bold text-white text-start">Shop</h1>
                    <p class="lead text-start">Discover and shop the best products with great deals and fast delivery!</p>
                </div>
            </div>
            <div class="bg-circle rounded-circle circle-shape-3 position-absolute bg-dark-light right-5"></div>
        </div>
    </section>-->
    <section class="page-header position-relative overflow-hidden ptb-mobile-120 bg-white">
    <div class="container">
      <nav aria-label="breadcrumb" class="d-flex justify-content-end">
          <ol class="breadcrumb mb-0">
              <li class="breadcrumb-item"><a href="https://www.mywingio.com/" class="underline-none" >Home</a></li>
              <li class="breadcrumb-item active" aria-current="page">Shop</li>
          </ol>
      </nav>
      <h4 class="unset-font-weight">Our Safe Phones</h4>
      <div class="mt-3">
        <div class="d-flex overflow-auto justify-content-center-custom">

          <!-- Product Card 1 -->
          <div v-for="(product) in productList" :key="product._id">
            <div class="card model-card flex-shrink-0" v-if="!product.name.includes('Tab')">
              <div class="card-body text-center">
                <a href="javascript:void(0)" @click="$router.push({ path: '/phone', query: { id: product._id } })">
                <div class="image-container mb-2">
                  <img :src="product.mainImage" class="product-img" >
                </div>
                </a>
                <!--<div class="color-dots mb-2">
                  <span style="background-color:#d2bba0;"></span>
                  <span style="background-color:#a3a3a3;"></span>
                  <span style="background-color:#1c1c1e;"></span>
                </div>-->
                  <h4 class="unset-font-weight">
                    <a class="product-name" :style="{ 'margin': 'unset', 'text-decoration': 'none' }" href="javascript:void(0)" @click="$router.push({ path: '/phone', query: { id: product._id } })">{{ product.displayName }}</a>
                  </h4>
                  <span class="h4 me-2 unset-font-weight">£{{ product.stripePriceDetail.unit_amount / 100 }}</span>
                <p class="unset-font-weight m-0">
                  <small>{{ product.name }}</small>
                </p>
                <!-- p class="text-muted mb-1 small">{{ product.memory }}, {{ product.camera }}</p> -->
                <div class="pt-3">
                  <a href="#" class="btn btn-primary unset-font-weight" @click="$router.push({ path: '/phone', query: { id: product._id } })">View Phone</a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <h4 class="pt-4 unset-font-weight">Our Safe Tablets</h4>
      <div>
        <div class="d-flex overflow-auto justify-content-center-custom">

          <!-- Product Card 1 -->
          <div v-for="(product) in productList" :key="product._id">
            <div class="card model-card flex-shrink-0" v-if="product.name.includes('Tab')">
              <div class="card-body text-center">
                <a href="javascript:void(0)" @click="$router.push({ path: '/phone', query: { id: product._id } })">
                <div class="image-container mb-2">
                  <img :src="product.mainImage" class="product-img" >
                </div>
                </a>
                
                <h4 class="unset-font-weight">
                  <a class="product-name" :style="{ 'margin': 'unset', 'text-decoration': 'none' }" href="javascript:void(0)" @click="$router.push({ path: '/phone', query: { id: product._id } })">{{ product.displayName }}</a>
                </h4>
                <span class="h4 me-2 unset-font-weight">£{{ product.stripePriceDetail.unit_amount / 100 }}</span>
                <p class="unset-font-weight m-0">
                  <small>{{ product.name }}</small>
                </p>
                <!-- p class="text-muted mb-1 small">{{ product.memory }}, {{ product.camera }}</p> -->
                <div class="pt-3">
                  <a href="#" class="btn btn-primary unset-font-weight" @click="$router.push({ path: '/phone', query: { id: product._id } })">View Tablet</a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    </section>

    <!--page header section end-->
    <!--<div class="container mt-5 mb-5">
        <div class="d-flex justify-content-center row">
            <div class="col-md-10">
                <div class="row p-2 bg-white border rounded" v-for="product in productList" :key="product._id">
                    <div class="col-md-3 mt-1"><img class="img-thumbnail w-50" :src="product.mainImage"></div>
                    <div class="col-md-6 mt-1">
                        <h5 class="text-start">
                          <a v-if="product.productType == 'Onetime'" href="javascript:void(0)" @click="$router.push({ path: '/phone', query: { id: product._id } })" :style="{ 'text-decoration': 'none' }">{{ product.name }}</a>
                          <p v-else>{{ product.name }}</p>
                        </h5>
                        <div v-if="product.productType == 'Onetime'">
                            <div class="mt-1 mb-1 spec-1 text-start"><span class="dot"></span><span>{{ product.memory }}</span></div>
                            <div class="mt-1 mb-1 spec-1 text-start"><span class="dot"></span><span>{{ product.camera }}</span></div>
                            <div class="mt-1 mb-1 spec-1 text-start"><span class="dot"></span><span>{{ product.battery }}</span></div>
                            <div class="mt-1 mb-1 spec-1 text-start"><span class="dot"></span><span>{{ product.screen }}</span></div>
                        </div>
                        <p class="text-justify text-truncate para mb-0 text-start">{{ product.shortDescription }}<br><br></p>
                        <div v-if="product.productType != 'Onetime'">
                            <div class="billing-container">
                                <div class="billing-option" v-for="prod in product.products" :key="prod._id">
                                    <input type="radio" @change="planChange(prod)" :id="prod.recurringIntervalType" name="billing" :checked="prod.recurringIntervalType == 'Monthly'">
                                    <label :for="prod.recurringIntervalType" class="radio-card-content">
                                        <span>{{ prod.recurringIntervalType }} billing</span>
                                        <span class="price">£{{ prod.stripePriceDetail.unit_amount / 100 }}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="align-items-center align-content-center col-md-3 border-left mt-1" v-if="product.productType == 'Onetime'">
                        <div class="d-flex flex-row align-items-center">
                            <h4 class="mr-1">£{{ product.stripePriceDetail.unit_amount / 100 }}</h4>
                        </div>
                        <h6 v-if="product.productType == 'Onetime' && stripeSubscriptionPlanDetail" class="text-start" :style="{ 'font-weight': 'unset' }">+ £{{ stripeSubscriptionPlanDetail.unit_amount / 100 }} Monthly Subscription</h6>
                        <h6 class="text-success text-start">Free shipping</h6>
                        <div class="d-flex flex-column mt-4">
                            <button v-if="product.productType == 'Onetime'" class="btn btn-primary btn-sm" type="button" @click="$router.push({ path: '/phone', query: { id: product._id } })">View Phone</button>
                            <button class="btn btn-outline-primary btn-sm mt-2" type="button" @click="addProductToCart(product, true)">Buy Now</button>
                        </div>
                    </div>
                    <div class="align-items-center align-content-center col-md-3 border-left mt-1" v-else>
                        <div class="d-flex flex-row align-items-center">
                            <h4 class="mr-1" v-if="selectedPlan">£{{ selectedPlan.unit_amount / 100 }}</h4>
                        </div>
                        <div class="d-flex flex-column mt-4">
                            <button class="btn btn-outline-primary btn-sm mt-2" type="button" @click="addProductToCart(product, true)">Buy Now</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>-->
  </div>
</template>

<script>
import PaymentService from "../services/PaymentService";

export default {
  name: 'Shop',
  components: {
    
  },
  props: {
  },
  data() {
    return {
      isDisabled: false,
      productList: [],
      stripeSubscriptionPlanDetail: null,
      selectedPlan: null,
    };

  },
  methods: {
    async getProducts() {
        await PaymentService.getProducts()
        .then((response) => {
          this.productList = response.data.data;
          this.stripeSubscriptionPlanDetail = response.data.defaultProduct;
          this.selectedPlan = this.stripeSubscriptionPlanDetail;
        }).catch((e) => {
          $toast.error(e.response.data.respones_msg);
        });
    },
    async addProductToCart(product, redirectToCartPage = false) {
        if (!product._id) {
          product.stripePriceDetail = this.selectedPlan;
          product.stripePriceId = this.selectedPlan.id;
        }
        
        let data = {
            productId: (product._id) ? product._id : this.selectedPlan.id,
            productDetail: product,
            qty: 1,
            subscriptionPriceId: this.stripeSubscriptionPlanDetail.id,
        }
        await PaymentService.addProductToCart(data)
        .then((response) => {
          this.$toast.success(response.data.respones_msg);
          if (redirectToCartPage == true) {
            this.$router.push({ path: '/cart'}) 
          }
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    planChange(prod) {
      this.selectedPlan = prod.stripePriceDetail;
    }
  },
  async beforeMount() {
    this.getProducts();
  },
  created () {
  },
}
</script>
<style scoped>

</style>